/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SuggestionCheckAvailableAliases {
  BUTTON_CONFIRM = 'button-confirm',
  CARD_APPOINTMENTS_TITLE_AVATAR_TITLE_ITEM_SUGGESTION_CHECK_AVAILIBLE = 'card-appointments-title-avatar-title-item-suggestion-check-availible',
  CONTEXTUAL_BAR_REQUEST = 'contextual-bar-request',
  FIELD_DATE = 'field-date',
  FIELD_OBS = 'field-obs',
  FIELD_PERIOD = 'field-period',
  FIELD_UPLOAD = 'field-upload',
  FILE_UPLOADER_REQUEST_FORMULARY_FILE_UPLOADER_SUGGESTION_CHECK_AVAILIBLE = 'file-uploader-request-formulary-file-uploader-suggestion-check-availible',
  FORM_REQUEST = 'form-request',
  GLOBAL_ACTIONS_MODAL = 'global-actions-modal',
  INPUT_REQUEST_FORMULARY_DATE_SUGGESTION_CHECK_AVAILIBLE = 'input-request-formulary-date-suggestion-check-availible',
  LAYOUT_CONTENT = 'layout-content',
  LAYOUT_REQUEST = 'layout-request',
  MAPPER_AVATAR = 'mapper-avatar',
  PANEL_CONTENT_SUGGESTION_CHECK_AVAILIBLE = 'panel-content-suggestion-check-availible',
  PANEL_ITEM_SUGGESTION_CHECK_AVAILIBLE = 'panel-item-suggestion-check-availible',
  PANEL_REQUEST_FORMULARY_PERIOD_SUGGESTION_CHECK_AVAILIBLE = 'panel-request-formulary-period-suggestion-check-availible',
  PANEL_REQUEST_FORMULARY_SUGGESTION_CHECK_AVAILIBLE = 'panel-request-formulary-suggestion-check-availible',
  SEGMENTED_CONTROL_PERIOD = 'segmented-control-period',
  TEXT_AREA_REQUEST_FORMULARY_OBS_SUGGESTION_CHECK_AVAILIBLE = 'text-area-request-formulary-obs-suggestion-check-availible',
  TEXT_REQUEST_FORMULARY_PERIOD_SUGGESTION_CHECK_AVAILIBLE = 'text-request-formulary-period-suggestion-check-availible',
}
export { SuggestionCheckAvailableAliases };
